import {
  Center,
  HStack,
  Heading,
  Skeleton,
  Spacer,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import useUserStore from '../../Hooks/Zustand/Store';
import { addDocumentFirebase, getCollectionFirebase, getSingleDocumentFirebase } from '../../Api/firebaseApi';
import { data } from '../../Components/Sidebar/DataMenu';

import BackButtons from '../../Components/Buttons/BackButtons';
import { extractPaths } from '../../Utils/roleAccessUtils';
import { useNavigate } from 'react-router-dom';
import DynamicButton from '../../Components/Buttons/DynamicButton';
import AccessNewRoleButton from '../../Components/Access/AccessNewRoleButton';
import AccessRoleUpdateButton from '../../Components/Access/AccessRoleUpdateButton';
import AccessRoleDeleteButton from '../../Components/Access/AccessRoleDeleteButton';
  
function SettingAccessPage() {
  const globalState = useUserStore();
  const [roleData, setRoleData] = useState();
  const [owner, setOwner] = useState([]);
  
  const router = useNavigate();
  
  const project = globalState?.projects.find((x) => x?.id === globalState?.currentProject);
  const ownerNames = owner?.map((x) => x?.name)?.join(', ');
  
  const getOwner = async () => {
    try {
      const ownerList = [];
      const promises = project?.owner?.map(async (x) => {
        const res = await getSingleDocumentFirebase('users', x);
        ownerList.push(res);
      });
      await Promise.all(promises);
      setOwner(ownerList);
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const getData = async () => {
    try {
      const filter = [
        { field: 'projectId', operator: '==', value: globalState?.currentProject },
        { field: 'companyId', operator: '==', value: globalState?.currentCompany },
        { field: 'module', operator: '==', value: 'hris' },
      ];
      const res = await getCollectionFirebase('role_access', filter);
  
      setRoleData(res);
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const createNewRole = async (roleName, users, isAll) => {
    if (!globalState?.currentProject || !globalState?.currentProject) return;
    try {
      const roleData = {
        appId: 'xxx',
        projectId: globalState?.currentProject,
        companyId: globalState?.currentCompany,
        module: 'hris',
        source: 'hris',
        title: roleName,
        users: users,
      };
  
      const docId = await addDocumentFirebase('role_access', roleData, globalState?.currentCompany);
      const access = extractPaths(data, isAll);
      const promises = access?.map(async (x) =>
        x?.map(async (y) => {
          const roleAccessData = {
            roleAccessId: docId,
            projectId: globalState?.currentProject,
            companyId: globalState?.currentCompany,
            path: y?.path,
            action: y?.action,
          };
          await addDocumentFirebase('role_access_data', roleAccessData, globalState?.currentCompany);
        })
      );
      await Promise.all(promises);
      setRoleData((prev) => {
        const newRoleData = [...prev];
        newRoleData.unshift({ id: docId, ...roleData });
  
        return newRoleData;
      });
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  useEffect(() => {
    if (globalState?.currentProject && project?.owner) {
      getOwner();
      getData();
    }
  }, [globalState?.currentProject && project?.owner]);
  
  return (
    <Stack p={[1, 1, 5]} spacing={5}>
      <HStack>
        <BackButtons />
        <Heading size={'md'}>Role Access</Heading>
        <Spacer />
        <AccessNewRoleButton roleData={roleData} action={createNewRole} />
      </HStack>
  
      <HStack>
        <Text fontWeight={500}>Owners: </Text>
        <Text whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {ownerNames}
        </Text>
      </HStack>
      {roleData ? (
        roleData?.length > 0 ? (
          <TableContainer borderRadius="10px" borderWidth="1px" borderColor={useColorModeValue('gray.100', 'gray.600')}>
            <Table>
              <Thead>
                <Tr>
                  <Th>Nama Role</Th>
                  <Th>#Users</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {roleData?.length > 0 &&
                    roleData?.map((x, i) => (
                      <Tr
                        key={i}
                        cursor="pointer"
                        _hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}
                        onClick={() => router(`/settings/access/${x?.id}`)}
                      >
                        <Td>{x?.title || 'Role name'}</Td>
                        <Td>{x?.users?.length || 0}</Td>
                        <Td>
                          <HStack>
                            <AccessRoleUpdateButton roleData={roleData} setRoleData={setRoleData} index={i} />
                            <AccessRoleDeleteButton roleData={roleData} setRoleData={setRoleData} index={i} />
                          </HStack>
                        </Td>
                      </Tr>
                    ))}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Stack>
            <Center h="60px" opacity={0.6}>
                Belum ada pengaturan akses
            </Center>
            <DynamicButton action="create" title="Buat Akses Dasar" onClick={() => createNewRole('users', project?.users || [], false)} />
          </Stack>
        )
      ) : (
        <Stack>
          <Skeleton h="45px" />
          <Skeleton h="45px" />
          <Skeleton h="45px" />
          <Skeleton h="45px" />
        </Stack>
      )}
    </Stack>
  );
}
  
export default SettingAccessPage;
  